// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

import API_CONFIG from "./api-config";

var redirectURL = API_CONFIG.API_ROOT.startsWith("//localhost:")
  ? API_CONFIG.LOCAL_REDIRECT
  : API_CONFIG.PROTOCOL + API_CONFIG.API_ROOT;

const awsmobile = {
  aws_project_region: "us-east-2",
  aws_cognito_identity_pool_id:
    "us-east-2:fab20945-baed-48cb-b4e7-c1b58f0fab1b",
  aws_cognito_region: "us-east-2",
  aws_user_pools_id: "us-east-2_RZKujFYGv",
  aws_user_pools_web_client_id: "gs5msdjr8vaudqnq8hvroqqfk",
  oauth: {
    domain: "pro-reviewer-dev.auth.us-east-2.amazoncognito.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: redirectURL,
    redirectSignOut: redirectURL,
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
};

export default awsmobile;
